export const PREFERRED_LANGUAGE_COOKIE_KEY = 'preferred_language';

export const EN = {
  value: 'en',
  // eslint-disable-next-line @gitlab/require-i18n-strings
  text: 'English',
};
